import { Divider } from '@chakra-ui/react';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { HEADER_HEIGHT } from '~/packages/header/ui/Header';
import { CollapsableSideBar } from '~/packages/sidebar/ui/CollapsableSideBar';
import { SideBarItem } from '~/packages/sidebar/ui/SideBarItem';

// Exports
type ValleyBankSideBarProps = {
  canToggleDataSource: boolean;
  isAssignmentEnabled?: boolean;
  isAdvanceRateEnabled?: boolean;
};
export const ValleyBankSideBar = ({
  canToggleDataSource,
  isAssignmentEnabled = true,
  isAdvanceRateEnabled = true,
}: ValleyBankSideBarProps) => {
  const { pathname: currentPath } = useLocation();
  return (
    <CollapsableSideBar
      additionalHeaderHeight={canToggleDataSource ? HEADER_HEIGHT : undefined}
    >
      <SideBarItem
        routeName="valley-bank/loan-accounts"
        currentPath={currentPath}
        label="Loan Accounts"
        icon="building-columns"
      />

      <SideBarItem
        routeName="valley-bank/customers"
        currentPath={currentPath}
        label="Customers"
        icon="user"
      />

      <SideBarItem
        routeName="valley-bank/arrangement-groups"
        currentPath={currentPath}
        label="Arrangement Groups"
        icon="folder-tree"
      />

      {isAssignmentEnabled && (
        <SideBarItem
          routeName="valley-bank/assignment"
          currentPath={currentPath}
          label="Assignment"
          icon="sliders"
        />
      )}

      {isAdvanceRateEnabled && (
        <SideBarItem
          routeName="valley-bank/advance-rate"
          currentPath={currentPath}
          label="Advance Rate"
          icon="money-check-dollar"
        />
      )}

      <Divider style={{ marginTop: '24px', marginBottom: '24px' }} />

      <SideBarItem
        routeName="settings"
        currentPath={currentPath}
        label="Settings"
        icon="gear"
      />
    </CollapsableSideBar>
  );
};
